const TTSignatureItemsContainer = ({ trophyInfo }) => {
  const iconYes = 'fa-solid fa-check fa-xl fa-beat text-success';
  const iconNo = 'fa-solid fa-xmark fa-xl fa-beat text-danger';
  const iconUnknown = 'fa-solid fa-question fa-xl fa-beat text-warning';

  const cssHasSachs = trophyInfo.hasSachs
    ? trophyInfo.hasSachs === '1'
      ? iconYes
      : iconNo
    : iconUnknown;
  const cssHasTrendlines = trophyInfo.hasTrendlines
    ? trophyInfo.hasTrendlines === '1'
      ? iconYes
      : iconNo
    : iconUnknown;
  const cssHasSpoiler = trophyInfo.hasSpoiler
    ? trophyInfo.hasSpoiler === '1'
      ? iconYes
      : iconNo
    : iconUnknown;
  const cssHasTurinis = trophyInfo.hasTurinis
    ? trophyInfo.hasTurinis === '1'
      ? iconYes
      : iconNo
    : iconUnknown;

  return (
    <>
      <h3 className="tt-heading text-warning">Signature Items</h3>
      <div className="mb-3">
        An indication as to whether or not the key signature items are present
        on this vehicle.
      </div>

      <div className="mb-5 container">
        <div className="row g-3 text-center">
          <div className="col-sm-6 col-xl-3">
            <div className="card bg-body-secondary border-0 shadow p-3 d-flex flex-row justify-content-between">
              <div className="text-white fw-bold">Sachs Dampers</div>
              <div>
                <i className={cssHasSachs} />
              </div>
            </div>
          </div>

          <div className="col-sm-6 col-xl-3">
            <div className="card bg-body-secondary border-0 shadow p-3 d-flex flex-row justify-content-between">
              <div className="text-white fw-bold">Recaro Trendlines</div>
              <div>
                <i className={cssHasTrendlines} />
              </div>
            </div>
          </div>

          <div className="col-sm-6 col-xl-3">
            <div className="card bg-body-secondary border-0 shadow p-3 d-flex flex-row justify-content-between">
              <div className="text-white fw-bold">V6 Roof Spoiler</div>
              <div>
                <i className={cssHasSpoiler} />
              </div>
            </div>
          </div>

          <div className="col-sm-6 col-xl-3">
            <div className="card bg-body-secondary border-0 shadow p-3 d-flex flex-row justify-content-between">
              <div className="text-white fw-bold">Trophy Turinis</div>
              <div>
                <i className={cssHasTurinis} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TTSignatureItemsContainer;
